import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent {

}


// WEBPACK FOOTER //
// ./src/app/layouts/full/full-layout.component.ts